import React from 'react';
import { Link } from 'react-router-dom';
import {
  resolvePrivacyPolicyHref,
  resolveTermsAndConditionsHref,
} from '../../constants/portalLegalUrlConstants';
import { isExternalLegalHref } from '../../utils/legalDocumentLink.utils';

export type LegalDocumentKind = 'privacy' | 'terms';

const HREF_RESOLVERS: Record<LegalDocumentKind, () => string> = {
  privacy: resolvePrivacyPolicyHref,
  terms: resolveTermsAndConditionsHref,
};

export interface LegalDocumentLinkProps {
  document: LegalDocumentKind;
  className?: string;
  children: React.ReactNode;
}

/**
 * Shared legal document link for footer and registration consent checkboxes.
 * Internal paths use React Router Link; external URLs use <a> with rel noopener.
 */
export const LegalDocumentLink: React.FC<LegalDocumentLinkProps> = ({
  document,
  className,
  children,
}) => {
  const href = HREF_RESOLVERS[document]();

  if (isExternalLegalHref(href)) {
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
};
